import { WorktreeSetupCard } from "./WorktreeSetupCard";
import type { MessagesTimelineRow } from "./MessagesTimeline.rowTypes";

/** Shows the admission setup card and limits Cancel to its running phase. */
export function TimelineWorktreeSetupRow({
  row,
}: {
  readonly row: Extract<MessagesTimelineRow, { kind: "worktree-setup" }>;
}) {
  return (
    <WorktreeSetupCard
      progress={row.progress}
      onCancel={row.progress.phase === "running" ? row.onCancel : null}
      onUseProjectCheckout={null}
      onEditMessage={null}
    />
  );
}
